import axios from 'axios'
import qs from 'qs'
import { Content } from '@/services/contentful/types'
import useApi from '../useApiV2'

interface QueryParams {
  contentType: 'pageCampaign' | 'pageExpressInterest' | 'pageInvestConfirmation'
  slug: string
}

function useContent<T>({ contentType, slug }: QueryParams) {
  const { data, isError, isLoading } = useApi<T>({
    key: `parties/${contentType}/${slug}`,
    request: () =>
      axios
        .get(
          `/api/contentful${qs.stringify(
            { contentType, slug },
            { addQueryPrefix: true }
          )}`
        )
        .then((res) => res.data?.content),
  })

  return {
    content: data,
    isError,
    isLoading,
  }
}

export function useAngelContent(entryId: string) {
  const { data, isError, isLoading } = useApi<Content>({
    key: `entry/${entryId}`,
    request: () =>
      axios
        .get(`/api/contentful/angel/entry?entryId=${entryId}`)
        .then((res) => {
          return res.data?.content
        }),
  })

  return {
    content: data,
    isError,
    isLoading,
  }
}

export default useContent
